import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconSquare = createSVG({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M3.492 6c0-.688.242-1.273.727-1.758.5-.5 1.093-.75 1.781-.75h12c.688 0 1.273.25 1.758.75.5.485.75 1.07.75 1.758v12c0 .688-.25 1.281-.75 1.781a2.394 2.394 0 0 1-1.758.727H6a2.473 2.473 0 0 1-1.781-.727A2.473 2.473 0 0 1 3.492 18V6zm-1.5 12c0 1.11.39 2.055 1.172 2.836.781.781 1.727 1.172 2.836 1.172h12c1.11 0 2.055-.39 2.836-1.172.781-.781 1.172-1.727 1.172-2.836V6c0-1.11-.39-2.055-1.172-2.836-.781-.781-1.727-1.172-2.836-1.172H6c-1.11 0-2.055.39-2.836 1.172C2.383 3.945 1.992 4.891 1.992 6v12z" }),
});

export { IconSquare };
